enum MapViewItemDrawnPart {
  Icon = 'icon',
  Label = 'label',
  Shape = 'shape',
}

export default MapViewItemDrawnPart
